/* eslint-disable react/prop-types */
import React from 'react';
import {useHistory} from 'react-router-dom';
import {HeaderContainer} from './elements';
import CloseIcon from '../../../../../../../../assets/icons/addadminclose.svg';

// const DELAY = 500;

export const ManageUnitHeader = ({orgClassId}) => {
  const history = useHistory();
  const onButtonCancel = () => {
    history.replace(`/admin/classes/view-class/${orgClassId}`);
  };
  return (
    <HeaderContainer>
      <div className="header-container fixed-top">
        <div className="manage-header">
          <div className="title">Manage Units</div>
          <div>
            <button className="btn" onClick={onButtonCancel} type="button">
              <img alt="Options" src={CloseIcon} />
            </button>
          </div>
        </div>
      </div>
    </HeaderContainer>
  );
};
